/**
 * @description API integration
 * @param id
 * @param params {post data}
 */
import axios from 'axios';
import querystring from 'querystring';

export default {
  signin(params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/admins/session`,
      headers: {
        'x-consumer': 'AdminWeb',
      },
      data: {
        email: params.email,
        password: params.password,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  signout() {
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/admins/session`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description 패스워드 리셋 이메일 요청(admin)
   */
  sendEmail(params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/admins/resetpassword`,
      headers: {
        'x-consumer': 'AdminWeb',
      },
      data: {
        email: params.email,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description 리셋패스워드 토큰 유효성검사
   */
  resetPasswordToken(token) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/resetpassword/${token}`,
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description 패스워드 리셋
   */
  resetPassword(token, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/resetpassword/${token}`,
      data: {
        password1: params.password1,
        password2: params.password2,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Doorlock 생성
   */
  createDoorlock(id, params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/doorlocks`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        name: params.name,
        type: params.type,
        hotel_id: params.hotel_id,
        ref_id: params.ref_id,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Doorlock 목록 조회
   */
  getDoorlockList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/doorlocks${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Doorlock 수정
   */
  updateDoorlock(id, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/doorlocks/${id.id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        name: params.name,
        pincode_version: params.pincode_version,
        pincode_length: params.pincode_length,
        pincode_day_type_offset: params.pincode_day_type_offset,
        is_pincode_issuable: params.is_pincode_issuable,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Doorlock 상세 조회
   */
  getDoorlockDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/doorlocks/${id.id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Doorlock uninstall
   */
  uninstallDoorlock(id) {
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/doorlocks/${id.id}/uninstall`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
      data: {
        hotel_id: id.hotel_id,
        doorlock_id: id.id,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Doorlock 목록 조회
   */
  getDoorlockLogList(id, query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/doorlocks/logs${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Doorlock battery history 조회
   */
  getDoorlockBatteryHitory(id, query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/doorlocks/${id.doorlock_id}/battery_history${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description User 생성
   */
  createUser(params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/users`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
      data: {
        email: params.email,
        name: params.name,
        password: params.password,
        tag: params.tag,
        device: params.device,
        os: params.os,
        push: params.push,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description User 목록 조회
   */
  getUserList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/users${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description User 수정
   */
  updateUser(id, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/users/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
      data: {
        name: params.name,
        password: params.password,
        tag: params.tag,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description User 상세 조회
   */
  getUserDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/users/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description User 삭제
   */
  deleteUser(id) {
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/users/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Domain 생성
   */
  createDomain(params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/domains`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
      data: {
        name: params.name,
        desc: params.desc,
        type: params.type,
        use_domain_init_card: params.use_domain_init_card,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Domain 목록 조회
   */
  getDomainList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/domains${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Domain 수정
   */
  updateDomain(id, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/domains/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
      data: {
        name: params.name,
        desc: params.desc,
        type: params.type,
        use_domain_init_card: params.use_domain_init_card,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Domain 상세 조회
   */
  getDomainDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/domains/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Domain 삭제
   */
  deleteDomain(id) {
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/domains/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Admin 목록 조회
   */
  getAdminList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/admins${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Admin 생성
   */
  createAdmin(params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/admins`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        // NOTE: 수정 가능한 데이터만 전송
        name: params.name,
        email: params.email,
        desc: params.desc,
        password: params.password,
        domain_id: params.domain_id,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Admin 조회
   */
  getAdminDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/admins/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Admin 업데이트
   */
  updateAdmin(id, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/admins/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        // NOTE: 수정 가능한 데이터만 전송
        name: params.name,
        email: params.email,
        desc: params.desc,
        password: params.password,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Admin 삭제
   */
  deleteAdmin(id) {
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/admins/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Booking 예약 목록 조회
   */
  getBookingList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/bookings${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Booking 예약 하기
   */
  createBooking(params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/bookings`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        user_email: params.user_email,
        hotel_id: params.hotel_id,
        roomtype_id: params.roomtype_id,
        checkin_at: params.checkin_at,
        checkout_at: params.checkout_at,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Booking 예약 상세 조회
   */
  getBookingDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/bookings/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Booking 예약 변경
   */
  updateBooking(id, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/bookings/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        roomtype_id: params.roomtype_id,
        checkin_at: params.checkin_at,
        checkout_at: params.checkout_at,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Hotel 목록 조회
   */
  getHotelList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Hotel 상세 조회
   */
  getHotelDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Hotel 정보 수정
   */
  updateHotel(id, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/hotels/${id}`,
      data: {
        name: params.name,
        address: params.address,
        timezone: params.timezone,
        desc: params.desc,
        checkin_hour: params.checkin_hour,
        checkout_hour: params.checkout_hour,
        checkin_minute: params.checkin_minute,
        checkout_minute: params.checkout_minute,
        latch_warning: params.latch_warning,
        tag: params.tag,
        type: params.type,
        pincode_version: params.pincode_version,
        pincode_length: params.pincode_length,
        pincode_day_type_offset: params.pincode_day_type_offset,
        is_pincode_issuable: params.is_pincode_issuable,
      },
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Building 목록 조회
   */
  getBuildingList(id, query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/buildings${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Building 개별 정보
   */
  getBuilding(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/buildings/${id.building_id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Floor 목록 조회
   */
  getFloorList(id, query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/buildings/${id.building_id}/floors${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Roomtype 목록 조회
   */
  getRoomtypeList(id, query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id}/roomtypes${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Room 목록 조회
   */
  getRoomList(id, query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id}/rooms${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Room 배정
   */
  setRoomAssign(id, params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/bookings/${id}/assignment`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        room_ids: params.room_ids,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Room 배정 취소
   */
  setRoomAssignCancel(id) {
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/bookings/${id}/assignment`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * TODO: API가 보이지 않지만 response data 존재함???
   * @link: https://api.hospitality-staging.imgate.co.kr/swagger/?url=/admin/swagger/v2/swagger.yaml#/
   * @description Staff 목록 조회
   */
  getStaffList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/staffs${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Staff 정보 조회
   */
  getStaffDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/staffs/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Staff 정보 변경
   */
  createStaff(id, params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/hotels/${id}/staffs`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        name: params.name,
        email: params.email,
        password: params.password,
        desc: params.desc,
        permission_ids: params.permission_ids,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Staff 정보 변경
   */
  updateStaff(hotelId, staffId, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/hotels/${hotelId}/staffs/${staffId}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        name: params.name,
        desc: params.desc,
        password: params.password,
        permission_ids: params.permission_ids,
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Staff 삭제
   */
  deleteStaff(id) {
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/hotels/${id.hotel_id}/staffs/${id.staff_id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Hotel Permission 목록 조회
   */
  getHotelPermission(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/hotels/${id}/permissions`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Permission 목록 조회
   */
  getPermission() {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/permissions`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
   * @description Hotel 생성
   */
  createHotel(params) {
    return axios({
      method: 'post',
      url: `${process.env.API_ENDPOINT}/hotels`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        name: params.name,
        address: params.address,
        timezone: params.timezone,
        desc: params.desc,
        checkin_hour: params.checkin_hour,
        checkout_hour: params.checkout_hour,
        tag: params.tag,
        type: params.type,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
   * @description Hotel 삭제
   */
  deleteHotel(hotelId, query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'delete',
      url: `${process.env.API_ENDPOINT}/hotels/${hotelId}${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
    })
      .then(result => Promise.resolve(result))
      .catch(err => Promise.reject(err));
  },
  /**
   * @description Hotel 생성
   * @param { String } hotel_id
   */
  updateHotelPermission(hotelId, params) {
    return axios({
      method: 'put',
      url: `${process.env.API_ENDPOINT}/hotels/${hotelId}/permissions`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
        'x-consumer': 'AdminWeb',
      },
      data: {
        permission_ids: params,
      },
    })
   .then(result => Promise.resolve(result))
   .catch(err => Promise.reject(err));
  },
  /**
 * @description Audit Log 목록 조회
 */
  getAuditLogList(query) {
    const questionMark = '?';
    const urlQueryString = questionMark.concat(querystring.stringify(query));
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/audit_logs${query ? urlQueryString : ''}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
 * @description Audit Log 상세 조회
 */
  getAuditLogDetail(id) {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/audit_logs/${id}`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
  /**
 * @description Audit Log action 조회
 */
  getActionList() {
    return axios({
      method: 'get',
      url: `${process.env.API_ENDPOINT}/audit_logs/action`,
      headers: {
        Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
      },
    })
    .then(result => Promise.resolve(result))
    .catch(err => Promise.reject(err));
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js